<template>
	<div class="" style="width: 100%; position: relative; overflow: hidden">
		<div
			style="width: 100%; height: 868px; position: absolute; z-index: 2"
		></div>
		<swiper class="swiper" :options="swiperOption">
			<swiper-slide>
				<div class="slide library pt-16">
					<div class="point d-flex align-center justify-center pt-1 mb-3">
						<img src="@/assets/images/library-icon.png" alt="" class="mr-4" />
						{{ $t('anywhere.sub-title.library') }}
					</div>
				</div>
			</swiper-slide>
			<swiper-slide>
				<div class="slide bus pt-16">
					<div class="point d-flex align-center justify-center pt-1 mb-3">
						<img src="@/assets/images/subway-icon.png" alt="" class="mr-4" />{{
							$t('anywhere.sub-title.subway')
						}}
					</div>
				</div>
			</swiper-slide>
			<swiper-slide>
				<div class="slide home pt-16">
					<div class="point d-flex align-center justify-center pt-1 mb-3">
						<img src="@/assets/images/home-icon.png" alt="" class="mr-4" />{{
							$t('anywhere.sub-title.home')
						}}
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div style="position: absolute; top: 15%; z-index: 2; width: 100%">
			<h1 class="main--title white-space-pre">
				{{ $t('anywhere.title') }}
			</h1>
		</div>
		<div style="position: absolute; bottom: 0; z-index: 2; width: 100%">
			<div class="d-flex justify-end">
				<v-spacer></v-spacer>
				<v-img
					width="75%"
					max-width="380"
					:lazy-src="require(`@/assets/images/mockup-hand-${language}.png`)"
					:src="require(`@/assets/images/mockup-hand-${language}@2x.png`)"
				></v-img>
			</div>
		</div>
	</div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
	components: {
		swiper,
		swiperSlide,
	},
	data() {
		return {
			swiperOption: {
				autoplay: {
					delay: 1500,
					disableOnInteraction: false,
				},
				// slidesPerView: 1.2,
				// centeredSlides: true,
				// spaceBetween: 15,
				loop: true,
			},
		}
	},
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.point {
	font-size: 16px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.8px;
	text-align: center;
	color: #2168ff;
}
.main--title {
	font-size: 28px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -1.4px;
	text-align: center;
	color: #1a1a1a;
}

.slide {
	width: 100%;
	height: 708px;
	background-size: cover;
}
.slide.bus {
	background-image: url('~@/assets/images/bus-bg-mobile.png');
}
.slide.home {
	background-image: url('~@/assets/images/home-bg-mobile.png');
}
.slide.library {
	background-image: url('~@/assets/images/library-bg-mobile.png');
}
</style>
